import React, { useState } from "react";
import { Button, SimpleGrid, Box, Text, Stack } from "@chakra-ui/react"; // Import required components
import CertificateVerifyModal from "./certificateverfication";
import CreateQuestionsModal from "./questionsGenerator"; // Import CreateQuestionsModal
import CsvUploader from "./csvUploader"; // Import CsvUploader
import { useRouter } from "next/router";

function Tools() {
  const router = useRouter();
  const [isCertificateVerifyModalOpen, setIsCertificateVerifyModalOpen] =
    useState(false);
  const [isCreateQuestionsModalOpen, setIsCreateQuestionsModalOpen] =
    useState(false);
  const [showCsvUploader, setShowCsvUploader] = useState(false); // State for CSV uploader visibility

  // Functions to handle opening and closing modals
  const handleOpenCertificateVerifyModal = () =>
    setIsCertificateVerifyModalOpen(true);
  const handleCloseCertificateVerifyModal = () =>
    setIsCertificateVerifyModalOpen(false);

  const handleOpenCreateQuestionsModal = () =>
    setIsCreateQuestionsModalOpen(true);
  const handleCloseCreateQuestionsModal = () =>
    setIsCreateQuestionsModalOpen(false);

  const handleToggleCsvUploader = () => setShowCsvUploader(!showCsvUploader); // Toggle CSV uploader visibility
  const signupNavigation = () => {
    router.push("/signUp");
  };

  return (
    <div style={{ marginTop: "20px" }}>
      {" "}
      {/* Adding some space from the top */}
      {/* SimpleGrid for arranging the tiles */}
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
        {/* Certificate Verification Tile */}
        <Box
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="lg"
          bg="teal.50" // Light teal background
          _hover={{
            bg: "teal.100", // Slightly darker on hover
            cursor: "pointer",
            transform: "scale(1.05)",
            boxShadow: "xl", // Enhance shadow on hover
          }}
          transition="all 0.2s ease-in-out" // Smooth transition for hover effects
          onClick={handleOpenCertificateVerifyModal}
        >
          <Text fontSize="xl" fontWeight="bold" color="teal.700">
            Certificate Verification
          </Text>
          <Text mt={2} color="teal.600">
            Verify certificates with ease and ensure validity.
          </Text>
        </Box>

        {/* Create Questions Tile */}
        <Box
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="lg"
          bg="blue.50" // Light blue background
          _hover={{
            bg: "blue.100", // Slightly darker on hover
            cursor: "pointer",
            transform: "scale(1.05)",
            boxShadow: "xl", // Enhance shadow on hover
          }}
          transition="all 0.2s ease-in-out"
          // onClick={handleOpenCreateQuestionsModal}

          onClick={signupNavigation}
        >
          <Text fontSize="xl" fontWeight="bold" color="blue.700">
            Create Interviews
          </Text>
          <Text mt={2} color="blue.600">
            Generate Multiple choice questions, Fill in the blanks, coding, and
            descriptive questions.
          </Text>
        </Box>

        {/* CSV Converter Tile */}
        {/* <Box
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="lg"
          bg="purple.50"  // Light purple background
          _hover={{
            bg: "purple.100",  // Slightly darker on hover
            cursor: "pointer",
            transform: "scale(1.05)",
            boxShadow: "xl",  // Enhance shadow on hover
          }}
          transition="all 0.2s ease-in-out"
          // onClick={handleToggleCsvUploader}  // Toggle CSV Uploader when clicked
        >
          <Text fontSize="xl" fontWeight="bold" color="purple.700">CSV Converter</Text>
          <Text mt={2} color="purple.600">Convert data from and to CSV formats easily.</Text>
        </Box> */}
      </SimpleGrid>
      {/* Modals */}
      <CertificateVerifyModal
        isCertificateVerifyModalOpen={isCertificateVerifyModalOpen}
        setIsCertificateVerifyModalOpen={handleCloseCertificateVerifyModal}
      />
      <CreateQuestionsModal
        isOpen={isCreateQuestionsModalOpen}
        onClose={handleCloseCreateQuestionsModal}
        userId={123} // Replace with actual user ID
        companyId={456} // Replace with actual company ID
      />
      {/* CSV Uploader Component */}
      {showCsvUploader && (
        <Box mt={4}>
          <CsvUploader /> {/* Show CSV Uploader when the tile is clicked */}
        </Box>
      )}
    </div>
  );
}

export default Tools;
